/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_Eb4_CarddetailsInputs */

const en_visa_eb4_carddetails = /** @type {(inputs: Visa_Eb4_CarddetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Employment-based immigrant classification for specific groups defined by U.S. immigration law.`)
};

const pt_visa_eb4_carddetails = /** @type {(inputs: Visa_Eb4_CarddetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classificação imigratória baseada em emprego para grupos específicos definidos pela legislação migratória dos EUA.`)
};

const es_visa_eb4_carddetails = /** @type {(inputs: Visa_Eb4_CarddetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clasificación migratoria basada en empleo para grupos específicos definidos por la legislación migratoria de EE. UU.`)
};

/**
* | output |
* | --- |
* | "Employment-based immigrant classification for specific groups defined by U.S. immigration law." |
*
* @param {Visa_Eb4_CarddetailsInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_eb4_carddetails = /** @type {((inputs?: Visa_Eb4_CarddetailsInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_Eb4_CarddetailsInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_eb4_carddetails(inputs)
	if (locale === "es") return es_visa_eb4_carddetails(inputs)
	return en_visa_eb4_carddetails(inputs)
});